module.exports = __webpack_public_path__ + "img/badge.d565da71.svg";